import * as SelectStyle from "@omni/ui/components/Form/Select/select.style";
import { hasWindow } from "@omni/utils/dom.utils";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";
import { GroupBase } from "react-select";
import { default as ReactCreatableSelect } from "react-select/creatable";

type Props<
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
> = ComponentProps<typeof ReactCreatableSelect<Option, IsMulti, Group>> & {
    isInvalid?: boolean;
    isValid?: boolean;
};

export const CreatableSelect = <
    Option = unknown,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>({
    className,
    isInvalid = false,
    isValid = false,
    ...props
}: Props<Option, IsMulti, Group>) => {
    return (
        <ReactCreatableSelect<Option, IsMulti, Group>
            {...props}
            menuPortalTarget={hasWindow() ? document.body : undefined}
            className={cn(SelectStyle.select(), className)}
            classNames={{
                ...props.classNames,
                container: () =>
                    cn(SelectStyle.container(), props.classNames?.container),
                control: ({ isFocused }) =>
                    cn(
                        SelectStyle.control({
                            isFocused: isFocused,
                            isInvalid: isInvalid,
                            isValid: isValid
                        }),
                        props.classNames?.control
                    ),
                valueContainer: () =>
                    cn(
                        SelectStyle.valueContainer(),
                        props.classNames?.valueContainer
                    ),
                clearIndicator: () =>
                    cn(
                        SelectStyle.clearIndicator(),
                        props.classNames?.clearIndicator
                    ),
                loadingIndicator: () =>
                    cn(
                        SelectStyle.loadingIndicator(),
                        props.classNames?.loadingIndicator
                    ),
                dropdownIndicator: () =>
                    cn(
                        SelectStyle.dropdownIndicator(),
                        props.classNames?.dropdownIndicator
                    ),
                indicatorSeparator: () =>
                    cn(
                        SelectStyle.indicatorSeparator(),
                        props.classNames?.indicatorSeparator
                    ),
                option: ({ isSelected, isFocused }) =>
                    cn(
                        SelectStyle.option({
                            isSelected: isSelected,
                            isFocused: isFocused
                        }),
                        props.classNames?.option
                    ),
                menuList: () =>
                    cn(SelectStyle.menuList(), props.classNames?.menuList),
                menu: () => cn("tw:overflow-hidden!", props.classNames?.menu),
                menuPortal: () => cn("tw:z-10!", props.classNames?.menuPortal)
            }}
        />
    );
};
